<template>
  <div>
    <div v-if="isScrolledMenu" id="scrolledSideMenuDiv" class="pl-3 pr-4 py-1 col-10 col-sm-9 col-md-6 col-lg-5 col-xl-4 text-secondary border border-300 rounded" @mouseover="onMouseOverScrolledSideMenuDiv()" @mouseleave="onMouseLeaveScrolledSideMenuDiv()">
      <div id="scrolledTitleDiv" class="clickable mb-2" v-on:click="toggleScrolledMenu">
        <slot name="title">
        </slot>
      </div>
      <div id="scrolledTitleDiv" class="clickable mb-2">
        <slot name="content">
        </slot>
      </div>
    </div>
    <div v-if="!isScrolledMenu" id="unscrolledSideMenuDiv" class="px-3 py-1 text-nowrap text-secondary border border-300 rounded">
      <div id="unscrolledTitleDiv" class="clickable" v-on:click="toggleScrolledMenu">
        <slot name="title">
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SideMenuDisplayer",
  data() {
    return {
      isScrolledMenu: false,
      autoCloseDelay: 1500,
      mouseLeaveDates: undefined
    };
  },
  mounted() {
  },
  updated: function() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    onMouseOverScrolledSideMenuDiv() {
      this.mouseLeaveDates = [];
    },
    onMouseLeaveScrolledSideMenuDiv() {
      if (this.mouseLeaveDates !== undefined) {
        const leaveDate = new Date();
        this.mouseLeaveDates.push(leaveDate);
        setTimeout(() => {
          if ((this.mouseLeaveDates !== undefined) && this.mouseLeaveDates.includes(leaveDate)) {
            this.isScrolledMenu = false;
          }
        }, this.autoCloseDelay);
      }
    },
    toggleScrolledMenu() {
      this.isScrolledMenu = !this.isScrolledMenu;
      this.mouseLeaveDates = undefined;
    },
    closeDisplayMessage() {
    },
    saveSelectedErrorToDisplayOnModal() {
    }
  }
}
</script>

<style scoped>

#unscrolledSideMenuDiv {
  position: absolute;
  z-index: 10;
  right: 0;
  transform: rotate(-90deg);
  transform-origin: right;
/*  background-color: rgba(245, 245, 245, 1);
  background-color: rgba(168, 133, 216, 1); 
  background-color: rgba(250, 245, 250, 1); */
  background-color: snow;
/*  box-shadow: -0.5rem 0.5rem 0.5rem white; */
  box-shadow: -0.25rem 0.25rem 1rem silver, 0.15rem -0.15rem 0.5rem white;
}

#scrolledSideMenuDiv {
  max-height: 80vh;
  overflow-y: scroll;
  overflow-x: hidden;
  position: absolute;
  z-index: 10;
  right: 0;
/*  background-color: rgba(245, 245, 245, 1);
  background-color: rgba(168, 133, 216, 1); 
  background-color: rgba(250, 245, 250, 1); */
  background-color: snow;
  /*
  box-shadow: 0.25rem 0.25rem 0.25rem silver, -0.5rem 0.5rem 0.5rem white;
  */
  box-shadow: 0.25rem 0.25rem 1rem silver, -0.15rem -0.15rem 0.5rem white;
}

.clickable {
  cursor: pointer
}

</style>